<div class="prime-card" @fadeSlideInUp>
    <img class="prime-card-glow-bottom" src="assets/svg/icons/glow.svg" />
    <div class="card-bottom-media">
        <img src="assets/svg/icons/bottom-media-profile-picture.svg" />
    </div>
    <section class="prime-card-body">
        <div class="content-wrapper">
            <div class="step-indicator step-indicator-w40">
                <div class="indicator-bar active"></div>
                <div class="indicator-bar"></div>
                <div class="indicator-bar"></div>
            </div>
            <h3 class="card-title-gradient">We’ll use a selfie to verify your identity</h3>
        </div>
    </section>

    <div class="prime-card-footer">
        <div class="prime-card-footer-right">
            <button type="submit" class="primary-fill-btn" (click)="startZoopLiveness()">
                Take Selfie
                <img class="icon-primary" src="assets/svg/icons/arrow-right-up.svg" alt="arrow-right-up" />
            </button>
        </div>
    </div>
</div>
